
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Phone, Settings } from "lucide-react";
import { useTestCall } from "@/hooks/screening/useTestCall";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { InfoIcon } from "lucide-react";

export default function TestCallSection() {
  const { phoneNumber, setPhoneNumber, isLoading, initiateTestCall } = useTestCall();
  const navigate = useNavigate();
  const [twilioConfigured, setTwilioConfigured] = useState<boolean | null>(null);
  
  useEffect(() => {
    const checkTwilioConfig = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('twilio-integration', {
          body: { action: 'checkConfig' }
        });
        
        if (!error && data) {
          setTwilioConfigured(data.configured);
        } else {
          setTwilioConfigured(false);
        }
      } catch (error) {
        console.error("Error checking Twilio config:", error);
        setTwilioConfigured(false);
      }
    };
    
    checkTwilioConfig();
  }, []);

  return (
    <div className="border rounded-md p-4 space-y-4">
      <h3 className="text-lg font-medium">Test Phone Integration</h3>
      
      {twilioConfigured === false && (
        <Alert variant="warning" className="mb-4">
          <InfoIcon className="h-4 w-4" />
          <AlertDescription>
            Twilio credentials are not configured. Please set them up in Integrations before testing.
          </AlertDescription>
        </Alert>
      )}
      
      <div className="space-y-2">
        <Label htmlFor="phone">Phone Number</Label>
        <Input
          id="phone"
          placeholder="Enter your phone number (e.g., 1234567890)"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      </div>
      
      <div className="flex flex-col gap-2">
        <Button 
          onClick={initiateTestCall} 
          disabled={isLoading || !phoneNumber || twilioConfigured === false}
          className="w-full"
        >
          {isLoading ? (
            "Initiating call..."
          ) : (
            <>
              <Phone className="w-4 h-4 mr-2" />
              Test Phone Call
            </>
          )}
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={() => navigate('/integrations?tab=twilio')}
          className="w-full"
        >
          <Settings className="w-4 h-4 mr-2" />
          Configure Twilio Credentials
        </Button>
      </div>
    </div>
  );
}
